import React, {FC} from 'react';

import {EffectCube, Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';

import './style.scss';

type PropsTypes = {
	items: {src: string; alt: string; title: string; type: number}[];
	className?: string;
};

const CubeSwiper: FC<PropsTypes> = ({items, className}) => {
	const slides = items.map(item => {
		return (
			<SwiperSlide key={item.type + item.alt}>
				<img src={item.src} alt={item.alt} title={item.title} />
			</SwiperSlide>
		);
	});

	return (
		<Swiper
			effect="cube"
			grabCursor
			cubeEffect={{
				shadow: true,
				slideShadows: true,
				shadowOffset: 20,
				shadowScale: 0.94,
			}}
			pagination
			navigation
			modules={[EffectCube, Pagination, Navigation]}
			className={`${className || 'mySwiper'}`}>
			{slides}
		</Swiper>
	);
};

export default CubeSwiper;
